import { render, staticRenderFns } from "./my-purshase-product.vue?vue&type=template&id=3d34658e&scoped=true"
import script from "./my-purshase-product.vue?vue&type=script&lang=js"
export * from "./my-purshase-product.vue?vue&type=script&lang=js"
import style0 from "./my-purshase-product.vue?vue&type=style&index=0&id=3d34658e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d34658e",
  null
  
)

export default component.exports